/* eslint-disable */
/* THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Regenerate via src/api/scripts/generator.sh */
/* generator-hash: 4eacdbdc82f5f081d8519f92f817d50ebadb0278a41ce619e6888568b3d66c61 */
import { emptySplitApi as api } from '../emptyApi'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCasesByCaseIdComments: build.query<
      GetCasesByCaseIdCommentsApiResponse,
      GetCasesByCaseIdCommentsApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/cases/${queryArg.caseId}/comments`,
        headers: {},
      }),
    }),
    postCasesByCaseIdComments: build.mutation<
      PostCasesByCaseIdCommentsApiResponse,
      PostCasesByCaseIdCommentsApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/cases/${queryArg.caseId}/comments`,
        method: 'POST',
        body: queryArg.commentUpdateModel,
        headers: {},
      }),
    }),
    putCasesByCaseIdCommentsAndCommentId: build.mutation<
      PutCasesByCaseIdCommentsAndCommentIdApiResponse,
      PutCasesByCaseIdCommentsAndCommentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/cases/${queryArg.caseId}/comments/${queryArg.commentId}`,
        method: 'PUT',
        body: queryArg.commentUpdateModel,
        headers: {},
      }),
    }),
    deleteCasesByCaseIdCommentsAndCommentId: build.mutation<
      DeleteCasesByCaseIdCommentsAndCommentIdApiResponse,
      DeleteCasesByCaseIdCommentsAndCommentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/cases/${queryArg.caseId}/comments/${queryArg.commentId}`,
        method: 'DELETE',
        headers: {},
      }),
    }),
    getBoardperiods: build.query<
      GetBoardperiodsApiResponse,
      GetBoardperiodsApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/clients/${queryArg.clientId ?? ':clientId'}/boardperiods`,
        headers: {},
      }),
    }),
    postCasesByCaseIdAttachments: build.mutation<
      PostCasesByCaseIdAttachmentsApiResponse,
      PostCasesByCaseIdAttachmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/cases/${queryArg.caseId}/attachments`,
        method: 'POST',
        body: queryArg.body,
        headers: {},
      }),
    }),
    getCasesByCaseIdAttachments: build.query<
      GetCasesByCaseIdAttachmentsApiResponse,
      GetCasesByCaseIdAttachmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/cases/${queryArg.caseId}/attachments`,
        headers: {},
      }),
    }),
    getCasesByCaseIdAttachmentsAndAttachmentId: build.query<
      GetCasesByCaseIdAttachmentsAndAttachmentIdApiResponse,
      GetCasesByCaseIdAttachmentsAndAttachmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/cases/${queryArg.caseId}/attachments/${queryArg.attachmentId}`,
        headers: {},
      }),
    }),
    deleteCasesByCaseIdAttachmentsAndAttachmentId: build.mutation<
      DeleteCasesByCaseIdAttachmentsAndAttachmentIdApiResponse,
      DeleteCasesByCaseIdAttachmentsAndAttachmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/cases/${queryArg.caseId}/attachments/${queryArg.attachmentId}`,
        method: 'DELETE',
        headers: {},
      }),
    }),
    postCasesList: build.query<PostCasesListApiResponse, PostCasesListApiArg>({
      query: (queryArg) => ({
        url: `/boardmeetings/cases/query`,
        method: 'POST',
        body: queryArg.casesQueryModel,
        headers: {},
      }),
    }),
    getCasesByCaseId: build.query<
      GetCasesByCaseIdApiResponse,
      GetCasesByCaseIdApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/cases/${queryArg.caseId}`,
        headers: {},
      }),
    }),
    putCasesByCaseId: build.mutation<
      PutCasesByCaseIdApiResponse,
      PutCasesByCaseIdApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/cases/${queryArg.caseId}`,
        method: 'PUT',
        body: queryArg.casePutModel,
        headers: {},
      }),
    }),
    putCasesByCaseIdDeleted: build.mutation<
      PutCasesByCaseIdDeletedApiResponse,
      PutCasesByCaseIdDeletedApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/cases/${queryArg.caseId}/deleted`,
        method: 'PUT',
        body: queryArg.casePutDeletedModel,
        headers: {},
      }),
    }),
    postCases: build.mutation<PostCasesApiResponse, PostCasesApiArg>({
      query: (queryArg) => ({
        url: `/boardmeetings/cases`,
        method: 'POST',
        body: queryArg.casePostModel,
        headers: {},
      }),
    }),
    putCasesByCaseIdDescription: build.mutation<
      PutCasesByCaseIdDescriptionApiResponse,
      PutCasesByCaseIdDescriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/cases/${queryArg.caseId}/description`,
        method: 'PUT',
        body: queryArg.casePutDescriptionModel,
        headers: {},
      }),
    }),
    putCasesByCaseIdSuggesteddecision: build.mutation<
      PutCasesByCaseIdSuggesteddecisionApiResponse,
      PutCasesByCaseIdSuggesteddecisionApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/cases/${queryArg.caseId}/suggesteddecision`,
        method: 'PUT',
        body: queryArg.casePutSuggestedDecisionModel,
        headers: {},
      }),
    }),
    getMeetingsByMeetingIdAgenda: build.query<
      GetMeetingsByMeetingIdAgendaApiResponse,
      GetMeetingsByMeetingIdAgendaApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/agenda`,
        headers: {},
      }),
    }),
    putMeetingsByMeetingIdAgenda: build.mutation<
      PutMeetingsByMeetingIdAgendaApiResponse,
      PutMeetingsByMeetingIdAgendaApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/agenda`,
        method: 'PUT',
        body: queryArg.meetingAgendaPutModel,
        headers: {},
      }),
    }),
    putMeetingsByMeetingIdAgendaAndCaseId: build.mutation<
      PutMeetingsByMeetingIdAgendaAndCaseIdApiResponse,
      PutMeetingsByMeetingIdAgendaAndCaseIdApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/agenda/${queryArg.caseId}`,
        method: 'PUT',
        headers: {},
      }),
    }),
    deleteMeetingsByMeetingIdAgendaAndCaseId: build.mutation<
      DeleteMeetingsByMeetingIdAgendaAndCaseIdApiResponse,
      DeleteMeetingsByMeetingIdAgendaAndCaseIdApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/agenda/${queryArg.caseId}`,
        method: 'DELETE',
        headers: {},
      }),
    }),
    getMeetingsByMeetingIdAgendaAndCaseId: build.query<
      GetMeetingsByMeetingIdAgendaAndCaseIdApiResponse,
      GetMeetingsByMeetingIdAgendaAndCaseIdApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/agenda/${queryArg.caseId}`,
        headers: {},
      }),
    }),
    getMeetingsByMeetingIdComments: build.query<
      GetMeetingsByMeetingIdCommentsApiResponse,
      GetMeetingsByMeetingIdCommentsApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/comments`,
        headers: {},
      }),
    }),
    postMeetingsByMeetingIdComments: build.mutation<
      PostMeetingsByMeetingIdCommentsApiResponse,
      PostMeetingsByMeetingIdCommentsApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/comments`,
        method: 'POST',
        body: queryArg.commentUpdateModel,
        headers: {},
      }),
    }),
    putMeetingsByMeetingIdCommentsAndCommentId: build.mutation<
      PutMeetingsByMeetingIdCommentsAndCommentIdApiResponse,
      PutMeetingsByMeetingIdCommentsAndCommentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/comments/${queryArg.commentId}`,
        method: 'PUT',
        body: queryArg.commentUpdateModel,
        headers: {},
      }),
    }),
    deleteMeetingsByMeetingIdCommentsAndCommentId: build.mutation<
      DeleteMeetingsByMeetingIdCommentsAndCommentIdApiResponse,
      DeleteMeetingsByMeetingIdCommentsAndCommentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/comments/${queryArg.commentId}`,
        method: 'DELETE',
        headers: {},
      }),
    }),
    getMeetingsByMeetingIdParticipantsForedit: build.query<
      GetMeetingsByMeetingIdParticipantsForeditApiResponse,
      GetMeetingsByMeetingIdParticipantsForeditApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/participants/foredit`,
        headers: {},
        params: {
          newTimeOfMeeting: queryArg.newTimeOfMeeting,
        },
      }),
    }),
    getMeetingsByMeetingIdParticipants: build.query<
      GetMeetingsByMeetingIdParticipantsApiResponse,
      GetMeetingsByMeetingIdParticipantsApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/participants`,
        headers: {},
      }),
    }),
    patchMeetingsByMeetingIdParticipants: build.mutation<
      PatchMeetingsByMeetingIdParticipantsApiResponse,
      PatchMeetingsByMeetingIdParticipantsApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/participants`,
        method: 'PATCH',
        body: queryArg.body,
        headers: {},
      }),
    }),
    postMeetingsByMeetingIdEmailnotificationAll: build.mutation<
      PostMeetingsByMeetingIdEmailnotificationAllApiResponse,
      PostMeetingsByMeetingIdEmailnotificationAllApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/emailnotification/all`,
        method: 'POST',
        headers: {},
      }),
    }),
    postMeetingsByMeetingIdEmailnotification: build.mutation<
      PostMeetingsByMeetingIdEmailnotificationApiResponse,
      PostMeetingsByMeetingIdEmailnotificationApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/emailnotification`,
        method: 'POST',
        body: queryArg.body,
        headers: {},
      }),
    }),
    getMeetingsByMeetingIdProtocol: build.query<
      GetMeetingsByMeetingIdProtocolApiResponse,
      GetMeetingsByMeetingIdProtocolApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/protocol`,
        headers: {},
      }),
    }),
    postMeetingsList: build.query<
      PostMeetingsListApiResponse,
      PostMeetingsListApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/query`,
        method: 'POST',
        body: queryArg.meetingsQueryModel,
        headers: {},
      }),
    }),
    getMeetingsByMeetingId: build.query<
      GetMeetingsByMeetingIdApiResponse,
      GetMeetingsByMeetingIdApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}`,
        headers: {},
      }),
    }),
    patchMeetingsByMeetingId: build.mutation<
      PatchMeetingsByMeetingIdApiResponse,
      PatchMeetingsByMeetingIdApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}`,
        method: 'PATCH',
        body: queryArg.body,
        headers: {},
      }),
    }),
    deleteMeetingsByMeetingId: build.mutation<
      DeleteMeetingsByMeetingIdApiResponse,
      DeleteMeetingsByMeetingIdApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}`,
        method: 'DELETE',
        headers: {},
      }),
    }),
    getMeetingsByMeetingIdNotice: build.query<
      GetMeetingsByMeetingIdNoticeApiResponse,
      GetMeetingsByMeetingIdNoticeApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/notice`,
        headers: {},
      }),
    }),
    getMeetingsByMeetingIdEvent: build.query<
      GetMeetingsByMeetingIdEventApiResponse,
      GetMeetingsByMeetingIdEventApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/event`,
        headers: {},
      }),
    }),
    postMeetings: build.mutation<PostMeetingsApiResponse, PostMeetingsApiArg>({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings`,
        method: 'POST',
        body: queryArg.createMeetingModel,
        headers: {},
      }),
    }),
    postMeetingsByMeetingIdOngoing: build.mutation<
      PostMeetingsByMeetingIdOngoingApiResponse,
      PostMeetingsByMeetingIdOngoingApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/ongoing`,
        method: 'POST',
        headers: {},
      }),
    }),
    postMeetingsByMeetingIdEditingUser: build.mutation<
      PostMeetingsByMeetingIdEditingUserApiResponse,
      PostMeetingsByMeetingIdEditingUserApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/editingUser`,
        method: 'POST',
        headers: {},
      }),
    }),
    postMeetingsByMeetingIdCancelled: build.mutation<
      PostMeetingsByMeetingIdCancelledApiResponse,
      PostMeetingsByMeetingIdCancelledApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/cancelled`,
        method: 'POST',
        headers: {},
      }),
    }),
    postMeetingsByMeetingIdConducted: build.mutation<
      PostMeetingsByMeetingIdConductedApiResponse,
      PostMeetingsByMeetingIdConductedApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/conducted`,
        method: 'POST',
        headers: {},
      }),
    }),
    postMeetingsByMeetingIdCompleted: build.mutation<
      PostMeetingsByMeetingIdCompletedApiResponse,
      PostMeetingsByMeetingIdCompletedApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/completed`,
        method: 'POST',
        body: queryArg.meetingCompletedRequestModel,
        headers: {},
      }),
    }),
    putMeetingsByMeetingIdCasesAndCaseIdDecision: build.mutation<
      PutMeetingsByMeetingIdCasesAndCaseIdDecisionApiResponse,
      PutMeetingsByMeetingIdCasesAndCaseIdDecisionApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/cases/${queryArg.caseId}/decision`,
        method: 'PUT',
        body: queryArg.newDecisionRequestModel,
        headers: {},
      }),
    }),
    putMeetingsByMeetingIdCasesAndCaseIdDecisionText: build.mutation<
      PutMeetingsByMeetingIdCasesAndCaseIdDecisionTextApiResponse,
      PutMeetingsByMeetingIdCasesAndCaseIdDecisionTextApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/cases/${queryArg.caseId}/decision/text`,
        method: 'PUT',
        body: queryArg.decisionTextPutModel,
        headers: {},
      }),
    }),
    postMeetingsByMeetingIdCasesAndCaseIdDecisionReverted: build.mutation<
      PostMeetingsByMeetingIdCasesAndCaseIdDecisionRevertedApiResponse,
      PostMeetingsByMeetingIdCasesAndCaseIdDecisionRevertedApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/cases/${queryArg.caseId}/decision/reverted`,
        method: 'POST',
        headers: {},
      }),
    }),
    postMeetingsByMeetingIdSigningcancelled: build.mutation<
      PostMeetingsByMeetingIdSigningcancelledApiResponse,
      PostMeetingsByMeetingIdSigningcancelledApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/signingcancelled`,
        method: 'POST',
        headers: {},
      }),
    }),
    postMeetingsByMeetingIdSigned: build.mutation<
      PostMeetingsByMeetingIdSignedApiResponse,
      PostMeetingsByMeetingIdSignedApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/signed`,
        method: 'POST',
        headers: {},
      }),
    }),
    getMeetingsByMeetingIdProtocolSigningSignatories: build.query<
      GetMeetingsByMeetingIdProtocolSigningSignatoriesApiResponse,
      GetMeetingsByMeetingIdProtocolSigningSignatoriesApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/protocol/signing/signatories`,
        headers: {},
      }),
    }),
    getMeetingsByMeetingIdProtocolSigning: build.query<
      GetMeetingsByMeetingIdProtocolSigningApiResponse,
      GetMeetingsByMeetingIdProtocolSigningApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/protocol/signing`,
        headers: {},
      }),
    }),
    putMeetingsByMeetingIdProtocolShared: build.mutation<
      PutMeetingsByMeetingIdProtocolSharedApiResponse,
      PutMeetingsByMeetingIdProtocolSharedApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/protocol/shared`,
        method: 'PUT',
        body: queryArg.protocolSharedRequestModel,
        headers: {},
      }),
    }),
    postMeetingsByMeetingIdCompletedandsignedcancelled: build.mutation<
      PostMeetingsByMeetingIdCompletedandsignedcancelledApiResponse,
      PostMeetingsByMeetingIdCompletedandsignedcancelledApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/completedandsignedcancelled`,
        method: 'POST',
        body: queryArg.commentUpdateModel,
        headers: {},
      }),
    }),
    postMeetingsByMeetingIdConductedcancelled: build.mutation<
      PostMeetingsByMeetingIdConductedcancelledApiResponse,
      PostMeetingsByMeetingIdConductedcancelledApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/meetings/${queryArg.meetingId}/conductedcancelled`,
        method: 'POST',
        body: queryArg.commentUpdateModel,
        headers: {},
      }),
    }),
    postCasesByCaseIdAttachmentsBoardarchive: build.mutation<
      PostCasesByCaseIdAttachmentsBoardarchiveApiResponse,
      PostCasesByCaseIdAttachmentsBoardarchiveApiArg
    >({
      query: (queryArg) => ({
        url: `/boardmeetings/cases/${queryArg.caseId}/attachments/boardarchive`,
        method: 'POST',
        body: queryArg.body,
        headers: {},
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as boardmeetings }
export type GetCasesByCaseIdCommentsApiResponse =
  /** status 201 Created */ CommentViewModel[]
export type GetCasesByCaseIdCommentsApiArg = {
  caseId: string
}
export type PostCasesByCaseIdCommentsApiResponse =
  /** status 200 OK */ CommentViewModel
export type PostCasesByCaseIdCommentsApiArg = {
  caseId: string
  commentUpdateModel: CommentUpdateModel
}
export type PutCasesByCaseIdCommentsAndCommentIdApiResponse = unknown
export type PutCasesByCaseIdCommentsAndCommentIdApiArg = {
  caseId: string
  commentId: string
  commentUpdateModel: CommentUpdateModel
}
export type DeleteCasesByCaseIdCommentsAndCommentIdApiResponse = unknown
export type DeleteCasesByCaseIdCommentsAndCommentIdApiArg = {
  caseId: string
  commentId: string
}
export type GetBoardperiodsApiResponse =
  /** status 200 OK */ BoardPeriodModelRead[]
export type GetBoardperiodsApiArg = {
  clientId?: string
}
export type PostCasesByCaseIdAttachmentsApiResponse = unknown
export type PostCasesByCaseIdAttachmentsApiArg = {
  caseId: string
  body: {
    files?: any
  }
}
export type GetCasesByCaseIdAttachmentsApiResponse = /** status 200 OK */ Blob
export type GetCasesByCaseIdAttachmentsApiArg = {
  caseId: string
}
export type GetCasesByCaseIdAttachmentsAndAttachmentIdApiResponse =
  /** status 200 OK */ Blob
export type GetCasesByCaseIdAttachmentsAndAttachmentIdApiArg = {
  caseId: string
  attachmentId: string
}
export type DeleteCasesByCaseIdAttachmentsAndAttachmentIdApiResponse = unknown
export type DeleteCasesByCaseIdAttachmentsAndAttachmentIdApiArg = {
  /** Case Id */
  caseId: string
  /** If of attachment to delete */
  attachmentId: string
}
export type PostCasesListApiResponse =
  /** status 200 OK */ BoardMeetingListModelQueryResultRead
export type PostCasesListApiArg = {
  casesQueryModel: CasesQueryModel
}
export type GetCasesByCaseIdApiResponse = /** status 200 OK */ CaseModel
export type GetCasesByCaseIdApiArg = {
  caseId: string
}
export type PutCasesByCaseIdApiResponse =
  /** status 200 OK */ CasePutResultModel
export type PutCasesByCaseIdApiArg = {
  caseId: string
  casePutModel: CasePutModel
}
export type PutCasesByCaseIdDeletedApiResponse =
  /** status 200 OK */ CasePutResultModel
export type PutCasesByCaseIdDeletedApiArg = {
  caseId: string
  casePutDeletedModel: CasePutDeletedModel
}
export type PostCasesApiResponse = /** status 201 Created */ CasePostResultModel
export type PostCasesApiArg = {
  casePostModel: CasePostModel
}
export type PutCasesByCaseIdDescriptionApiResponse =
  /** status 200 OK */ CasePutResultModel
export type PutCasesByCaseIdDescriptionApiArg = {
  caseId: string
  casePutDescriptionModel: CasePutDescriptionModel
}
export type PutCasesByCaseIdSuggesteddecisionApiResponse =
  /** status 200 OK */ CasePutResultModel
export type PutCasesByCaseIdSuggesteddecisionApiArg = {
  caseId: string
  casePutSuggestedDecisionModel: CasePutSuggestedDecisionModel
}
export type GetMeetingsByMeetingIdAgendaApiResponse =
  /** status 200 OK */ MeetingAgendaModel[]
export type GetMeetingsByMeetingIdAgendaApiArg = {
  /** Meeting id */
  meetingId: string
}
export type PutMeetingsByMeetingIdAgendaApiResponse = unknown
export type PutMeetingsByMeetingIdAgendaApiArg = {
  /** Meeting id */
  meetingId: string
  meetingAgendaPutModel: MeetingAgendaPutModel
}
export type PutMeetingsByMeetingIdAgendaAndCaseIdApiResponse = unknown
export type PutMeetingsByMeetingIdAgendaAndCaseIdApiArg = {
  /** Meeting id */
  meetingId: string
  /** Id of the case to connect */
  caseId: string
}
export type DeleteMeetingsByMeetingIdAgendaAndCaseIdApiResponse = unknown
export type DeleteMeetingsByMeetingIdAgendaAndCaseIdApiArg = {
  /** Meeting id */
  meetingId: string
  /** Id of the case to disconnect */
  caseId: string
}
export type GetMeetingsByMeetingIdAgendaAndCaseIdApiResponse =
  /** status 200 OK */ MeetingAgendaModel
export type GetMeetingsByMeetingIdAgendaAndCaseIdApiArg = {
  /** Meeting id */
  meetingId: string
  caseId: string
}
export type GetMeetingsByMeetingIdCommentsApiResponse =
  /** status 200 OK */ CommentViewModel[]
export type GetMeetingsByMeetingIdCommentsApiArg = {
  meetingId: string
}
export type PostMeetingsByMeetingIdCommentsApiResponse =
  /** status 200 OK */ CommentViewModel
export type PostMeetingsByMeetingIdCommentsApiArg = {
  meetingId: string
  commentUpdateModel: CommentUpdateModel
}
export type PutMeetingsByMeetingIdCommentsAndCommentIdApiResponse = unknown
export type PutMeetingsByMeetingIdCommentsAndCommentIdApiArg = {
  meetingId: string
  commentId: string
  commentUpdateModel: CommentUpdateModel
}
export type DeleteMeetingsByMeetingIdCommentsAndCommentIdApiResponse = unknown
export type DeleteMeetingsByMeetingIdCommentsAndCommentIdApiArg = {
  meetingId: string
  commentId: string
}
export type GetMeetingsByMeetingIdParticipantsForeditApiResponse =
  /** status 200 OK */ MeetingParticipantSelectedModelRead[]
export type GetMeetingsByMeetingIdParticipantsForeditApiArg = {
  /** Meeting id */
  meetingId: string
  newTimeOfMeeting?: string
}
export type GetMeetingsByMeetingIdParticipantsApiResponse =
  /** status 200 OK */ MeetingParticipantSelectedModelRead[]
export type GetMeetingsByMeetingIdParticipantsApiArg = {
  /** Meeting id */
  meetingId: string
}
export type PatchMeetingsByMeetingIdParticipantsApiResponse = unknown
export type PatchMeetingsByMeetingIdParticipantsApiArg = {
  meetingId: string
  body: Operation[]
}
export type PostMeetingsByMeetingIdEmailnotificationAllApiResponse = unknown
export type PostMeetingsByMeetingIdEmailnotificationAllApiArg = {
  meetingId: string
}
export type PostMeetingsByMeetingIdEmailnotificationApiResponse = unknown
export type PostMeetingsByMeetingIdEmailnotificationApiArg = {
  meetingId: string
  body: string[]
}
export type GetMeetingsByMeetingIdProtocolApiResponse =
  /** status 200 OK */ Blob
export type GetMeetingsByMeetingIdProtocolApiArg = {
  /** Meeting Id */
  meetingId: string
}
export type PostMeetingsListApiResponse =
  /** status 200 OK */ BoardMeetingListModelQueryResultRead
export type PostMeetingsListApiArg = {
  /** Query model */
  meetingsQueryModel: MeetingsQueryModel
}
export type GetMeetingsByMeetingIdApiResponse =
  /** status 200 OK */ BoardMeetingModelRead
export type GetMeetingsByMeetingIdApiArg = {
  /** Meeting id */
  meetingId: string
}
export type PatchMeetingsByMeetingIdApiResponse = unknown
export type PatchMeetingsByMeetingIdApiArg = {
  meetingId: string
  body: Operation[]
}
export type DeleteMeetingsByMeetingIdApiResponse =
  /** status 204 No Content */ BoardPeriodModelRead[]
export type DeleteMeetingsByMeetingIdApiArg = {
  meetingId: string
}
export type GetMeetingsByMeetingIdNoticeApiResponse = /** status 200 OK */ Blob
export type GetMeetingsByMeetingIdNoticeApiArg = {
  /** Meeting Id */
  meetingId: string
}
export type GetMeetingsByMeetingIdEventApiResponse = /** status 200 OK */ Blob
export type GetMeetingsByMeetingIdEventApiArg = {
  /** Meeting Id */
  meetingId: string
}
export type PostMeetingsApiResponse = unknown
export type PostMeetingsApiArg = {
  /** Create meeting model with required fields */
  createMeetingModel: CreateMeetingModel
}
export type PostMeetingsByMeetingIdOngoingApiResponse = unknown
export type PostMeetingsByMeetingIdOngoingApiArg = {
  meetingId: string
}
export type PostMeetingsByMeetingIdEditingUserApiResponse = unknown
export type PostMeetingsByMeetingIdEditingUserApiArg = {
  meetingId: string
}
export type PostMeetingsByMeetingIdCancelledApiResponse = unknown
export type PostMeetingsByMeetingIdCancelledApiArg = {
  meetingId: string
}
export type PostMeetingsByMeetingIdConductedApiResponse = unknown
export type PostMeetingsByMeetingIdConductedApiArg = {
  meetingId: string
}
export type PostMeetingsByMeetingIdCompletedApiResponse = unknown
export type PostMeetingsByMeetingIdCompletedApiArg = {
  meetingId: string
  meetingCompletedRequestModel: MeetingCompletedRequestModel
}
export type PutMeetingsByMeetingIdCasesAndCaseIdDecisionApiResponse = unknown
export type PutMeetingsByMeetingIdCasesAndCaseIdDecisionApiArg = {
  meetingId: string
  caseId: string
  newDecisionRequestModel: NewDecisionRequestModel
}
export type PutMeetingsByMeetingIdCasesAndCaseIdDecisionTextApiResponse =
  unknown
export type PutMeetingsByMeetingIdCasesAndCaseIdDecisionTextApiArg = {
  meetingId: string
  caseId: string
  decisionTextPutModel: DecisionTextPutModel
}
export type PostMeetingsByMeetingIdCasesAndCaseIdDecisionRevertedApiResponse =
  unknown
export type PostMeetingsByMeetingIdCasesAndCaseIdDecisionRevertedApiArg = {
  meetingId: string
  caseId: string
}
export type PostMeetingsByMeetingIdSigningcancelledApiResponse = unknown
export type PostMeetingsByMeetingIdSigningcancelledApiArg = {
  meetingId: string
}
export type PostMeetingsByMeetingIdSignedApiResponse = unknown
export type PostMeetingsByMeetingIdSignedApiArg = {
  meetingId: string
}
export type GetMeetingsByMeetingIdProtocolSigningSignatoriesApiResponse =
  /** status 200 OK */ SignedByUserModelRead[]
export type GetMeetingsByMeetingIdProtocolSigningSignatoriesApiArg = {
  /** Meeting id */
  meetingId: string
}
export type GetMeetingsByMeetingIdProtocolSigningApiResponse =
  /** status 200 OK */ SignatureResponseModel
export type GetMeetingsByMeetingIdProtocolSigningApiArg = {
  /** Meeting id */
  meetingId: string
}
export type PutMeetingsByMeetingIdProtocolSharedApiResponse = unknown
export type PutMeetingsByMeetingIdProtocolSharedApiArg = {
  /** Meeting id */
  meetingId: string
  /** Model for changing shared status for a meeting protocol */
  protocolSharedRequestModel: ProtocolSharedRequestModel
}
export type PostMeetingsByMeetingIdCompletedandsignedcancelledApiResponse =
  unknown
export type PostMeetingsByMeetingIdCompletedandsignedcancelledApiArg = {
  meetingId: string
  /** Required comment with minimum length of ten characters. Example value: INC1234567 */
  commentUpdateModel: CommentUpdateModel
}
export type PostMeetingsByMeetingIdConductedcancelledApiResponse = unknown
export type PostMeetingsByMeetingIdConductedcancelledApiArg = {
  meetingId: string
  /** Required comment with minimum length of ten characters. Example value: INC1234567 */
  commentUpdateModel: CommentUpdateModel
}
export type PostCasesByCaseIdAttachmentsBoardarchiveApiResponse = unknown
export type PostCasesByCaseIdAttachmentsBoardarchiveApiArg = {
  caseId: string
  body: string[]
}
export type PersonModel = {
  fullName?: string | null
  /** Nameid */
  id?: string | null
}
export type CommentViewModel = {
  id?: string | null
  createdDate?: string
  createdBy?: PersonModel
  editedDate?: string | null
  editedBy?: PersonModel
  deletedDate?: string | null
  deletedBy?: PersonModel
  commentText?: string | null
  type?: TimelineEnumType
  logActionEnum?: TimeLineLogActionEnum
}
export type ProblemDetails = {
  type?: string | null
  title?: string | null
  status?: number | null
  detail?: string | null
  instance?: string | null
  [key: string]: any
}
export type CommentUpdateModel = {
  /** The changed comment text. */
  text?: string | null
}
export type BoardPeriodModel = {
  /** Start of period */
  periodStart?: string
  /** End of period */
  periodEnd?: string | null
}
export type BoardPeriodModelRead = {
  /** Start of period */
  periodStart?: string
  /** End of period */
  periodEnd?: string | null
  /** Display name based on start/end */
  displayName?: string | null
}
export type BoardMeetingListModel = {
  /** Id of meeting */
  id?: string | null
  /** Title of meeting */
  title?: string | null
  /** Time of meeting */
  time?: string
  /** Participant count */
  attendantCount?: number
  /** Cases count */
  caseCount?: number
  status?: MeetingStatus
  /** Status as text */
  statusText?: string | null
  /** If meeting is shared with BBL
    <remarks>Delt med forretningsfører</remarks> */
  sharedWithBbl?: boolean
  /** Userid of user started or currently working on meeting */
  editingByUserId?: string | null
  /** True if SharedWithBbl is allowed to be changed, otherwise false.
    False is used for signed protocols shared using the old portal.
    When false sharing status must be managed from board documents. */
  canSharedWithBblBeChanged?: boolean
}
export type BoardMeetingListModelQueryResult = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: BoardMeetingListModel[] | null
}
export type BoardMeetingListModelQueryResultRead = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** If more pages */
  morePages?: boolean
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: BoardMeetingListModel[] | null
}
export type CasesQueryModel = {
  sortColumn?: CasesSortColumn
  queryStatus?: CaseQueryStatus
  /** Text to search for, accross searchfields */
  searchText?: string | null
  sortOrder?: SortOrder
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
  /** Client Id */
  clientId?: string | null
}
export type CaseLinkModel = {
  /** Link */
  link?: string | null
  /** If link property points to a inbox message */
  isLinkToInboxMessage?: boolean
}
export type ConnectedMeetingModel = {
  /** Id of meeting */
  id?: string | null
  /** Title of meeting */
  title?: string | null
  status?: MeetingStatus
}
export type DecisionModel = {
  /** Protocol number - provided when previous meeting was signed/completed
    <remarks>Protokollnummer</remarks> */
  procotolNumber?: number
  /** Description of decision */
  decisionText?: string | null
  /** Date of decision */
  decisionDate?: string
  meeting?: ConnectedMeetingModel
}
export type CaseModel = {
  /** CaseId */
  id?: string | null
  /** Title of the case */
  title?: string | null
  /** Submitted by - free text field in DB */
  submittedBy?: string | null
  responsible?: PersonModel
  caseType?: CaseType
  caseStatus?: CaseStatus
  /** Links/URLs */
  links?: CaseLinkModel[] | null
  /** Case description */
  description?: string | null
  /** Forslag til vedtak */
  suggestedDecision?: string | null
  /** Case deadline */
  deadline?: string | null
  connectedMeeting?: ConnectedMeetingModel
  /** All decisions stated on this case.
    <remarks>Tidligere vedtak</remarks> */
  decisions?: DecisionModel[] | null
  /** Datestamp of when case was last updated */
  lastUpdated?: string | null
}
export type CasePutResultModel = {
  /** When the case was last modified. */
  lastUpdated?: string
}
export type CasePutModel = {
  caseType?: CaseType
  /** Title of the case (required) */
  title?: string | null
  /** Case description (required) */
  description?: string | null
  /** Person that submitted the case (required) */
  submittedBy?: string | null
  /** Person responsible for case */
  responsibleNameId?: string | null
  /** Case deadline */
  deadline?: string | null
  /** Specified if the case should be connected to a meeting. The meeting must have status new or ongoing.
    If ConnectedMeetingId is set to null, and the case already is connected to a new/ongoing meeting, the case will be disconnected from the meeting.
    A case can only be connected to one new or ongoing meeting at the time. */
  connectedMeetingId?: string | null
  /** Suggested decision (required when CaseType is DecisionCase)
    Forslag til vedtak (påkrevd for beslutningssaker) */
  suggestedDecision?: string | null
  /** Links/URLs */
  links?: string[] | null
  /** Datestamp of when case was last updated.
    Used by the API to validate that the latest version of the case is being updated. */
  lastUpdated?: string
}
export type CasePutDeletedModel = {
  /** Datestamp of when case was last updated.
    Used by the API to validate that the latest version of the case is being updated. */
  lastUpdated?: string
  /** True to delete the case. False to undelete the case. */
  isDeleted?: boolean
}
export type CasePostResultModel = {
  /** Case id */
  id?: string | null
  /** When the case was last modified. Defaults to created date. */
  lastUpdated?: string
}
export type CaseInboxMessageModel = {
  inboxMessageId?: string | null
  messageType?: MessageType
}
export type CasePostModel = {
  /** Client Id (required)
    Norwegian: ForvaltningsklientId */
  clientId?: string | null
  caseType?: CaseType
  /** Title of the case (required) */
  title?: string | null
  /** Case description (required) */
  description?: string | null
  /** Person that submitted the case */
  submittedBy?: string | null
  /** Person responsible for case
    Norwegian: AnsvarligNavneregisterId */
  responsibleNameId?: string | null
  /** Case deadline */
  deadline?: string | null
  /** If case should be connected to a meeting */
  connectedMeetingId?: string | null
  /** Forslag til vedtak (required when CaseType is DecisionCase) */
  suggestedDecision?: string | null
  /** Links/URLs */
  links?: string[] | null
  inboxMessageModel?: CaseInboxMessageModel
}
export type CasePutDescriptionModel = {
  /** Datestamp of when case was last updated.
    Used by the API to validate that the latest version of the case is being updated. */
  lastUpdated?: string
  /** Case description (required) */
  description?: string | null
}
export type CasePutSuggestedDecisionModel = {
  /** Datestamp of when case was last updated.
    Used by the API to validate that the latest version of the case is being updated. */
  lastUpdated?: string
  /** Suggested decision (required when CaseType is DecisionCase)
    Forslag til vedtak (påkrevd for beslutningssaker) */
  suggestedDecision?: string | null
}
export type VoteModel = {
  nameId?: string | null
  name?: string | null
  boardFunction?: string | null
  vote?: VoteStatus
}
export type AttachmentModel = {
  /** Filename of attachment */
  filename?: string | null
  /** Id, used to download attahment */
  id?: string | null
  /** Content type in form "application/pdf". */
  contentType?: string | null
}
export type MeetingAgendaModel = {
  /** Id of agenda entry
    <remarks>MoetesakId</remarks> */
  agendaId?: string | null
  /** Id of case
    <remarks>MoetesakId</remarks> */
  caseId?: string | null
  /** Order in given meeting */
  order?: number
  /** Case title */
  title?: string | null
  /** Case description */
  description?: string | null
  type?: CaseType
  responsible?: PersonModel
  /** The name of the person who submitted the case
    <remarks>Innmeldt av</remarks> */
  submittedBy?: string | null
  /** Deadline of case
    <remarks>Frist</remarks> */
  deadline?: string | null
  /** Flag for if case is based upon standard case templates
    <remarks>Fast sak</remarks> */
  isStandardCase?: boolean
  status?: CaseStatus
  votingStatus?: VoteStatus
  votes?: VoteModel[] | null
  decision?: string | null
  suggestedDecision?: string | null
  /** True if the case has been given case status Completed, Postponed or ForFollowup during this meeting */
  isProcessedInThisMeeting?: boolean
  links?: CaseLinkModel[] | null
  attachments?: AttachmentModel[] | null
}
export type MeetingAgendaUpdateModel = {
  /** Case Id of agenda entry */
  caseId?: string | null
  /** New Order */
  order?: number
}
export type MeetingAgendaPutModel = {
  /** Email recipient model */
  agenda?: MeetingAgendaUpdateModel[] | null
}
export type MeetingParticipantSelectedModel = {
  /** True if the person has been, or is about to be, added to the meeting notice */
  selected?: boolean
  /** This flag is intended for validation before patching the meeting's from date.
    True indicates that this participant prevents changing the time of meeting to the new value
    due to the participants's board function having changed during the period between the new value and the current value.
    The participant must therefore be manually removed by the user before the user can set the new time of meeting.
    This property is used (as in can be set to true) only when endpoint participants/foredit is called with a value for newTimeOfMeeting.
    In other words, if newTimeOfMeeting is null this property will always be false. */
  mustBeRemovedBeforeSpecifiedNewTimeOfMeetingCanBeApplied?: boolean
  /** Unique id of the participant, for this meeting */
  participantId?: string | null
  /** Full name of participant */
  name?: string | null
  /** Firstname of participant */
  firstname?: string | null
  /** If participant was in board at time of meeting, field will include board function (styreleder, styremedlem, etc), value comes from the enum "BoardFunction".Code() */
  boardFunction?: string | null
  /** Name of board function held at time of meeting so custom defined roles is shown in UI */
  boardFunctionCustomName?: string | null
  /** For external participants */
  email?: string | null
  /** Nameregister entry of participant - (if not external) */
  nameregisterId?: string | null
  /** Board contact number of participant - (if external) */
  boardContactNumber?: number | null
  /** If participant can vote or not
    <remarks>Stemmerett</remarks> */
  canVote?: boolean
  /**  If participant is meeting chair/head of meeting
    <remarks>Møteleder</remarks> */
  meetingChair?: boolean
  /** When løast e-mail notification was sent */
  emailLastSent?: string | null
  /** If person attended */
  hasMet?: boolean
  /** Date/time rejected meeting */
  rejectedAt?: string | null
  /** Date/time approved meeting */
  approvedAt?: string | null
  /** If participant can sign meeting protocol or not
    <remarks>Kan signere protokoll</remarks> */
  canSign?: boolean
  /** True if the meeting participant was in the board at time of meeting, but isn't in the current board. */
  hasLeftBoardSinceTimeOfMeeting?: boolean
}
export type MeetingParticipantSelectedModelRead = {
  /** True if the person has been, or is about to be, added to the meeting notice */
  selected?: boolean
  /** This flag is intended for validation before patching the meeting's from date.
    True indicates that this participant prevents changing the time of meeting to the new value
    due to the participants's board function having changed during the period between the new value and the current value.
    The participant must therefore be manually removed by the user before the user can set the new time of meeting.
    This property is used (as in can be set to true) only when endpoint participants/foredit is called with a value for newTimeOfMeeting.
    In other words, if newTimeOfMeeting is null this property will always be false. */
  mustBeRemovedBeforeSpecifiedNewTimeOfMeetingCanBeApplied?: boolean
  /** Unique id of the participant, for this meeting */
  participantId?: string | null
  /** Full name of participant */
  name?: string | null
  /** Firstname of participant */
  firstname?: string | null
  /** If participant was in board at time of meeting, field will include board function (styreleder, styremedlem, etc), value comes from the enum "BoardFunction".Code() */
  boardFunction?: string | null
  /** Name of board function held at time of meeting so custom defined roles is shown in UI */
  boardFunctionCustomName?: string | null
  /** For external participants */
  email?: string | null
  /** Nameregister entry of participant - (if not external) */
  nameregisterId?: string | null
  /** Board contact number of participant - (if external) */
  boardContactNumber?: number | null
  /** If participant can vote or not
    <remarks>Stemmerett</remarks> */
  canVote?: boolean
  /**  If participant is meeting chair/head of meeting
    <remarks>Møteleder</remarks> */
  meetingChair?: boolean
  /** When løast e-mail notification was sent */
  emailLastSent?: string | null
  /** If person attended */
  hasMet?: boolean
  /** Date/time rejected meeting */
  rejectedAt?: string | null
  /** Date/time approved meeting */
  approvedAt?: string | null
  /** Used to sort a list by roles */
  sortValue?: string | null
  /** If participant can sign meeting protocol or not
    <remarks>Kan signere protokoll</remarks> */
  canSign?: boolean
  /** True if the meeting participant was in the board at time of meeting, but isn't in the current board. */
  hasLeftBoardSinceTimeOfMeeting?: boolean
}
export type Operation = {
  value?: any | null
  path?: string | null
  op?: string | null
  from?: string | null
}
export type MeetingsQueryModel = {
  sortColumn?: MeetingsSortColumn
  queryStatus?: MeetingQueryStatus
  /** Specify to filter on meetings with time after given date */
  from?: string | null
  /** Specify to filter on meetings with time up until given date */
  to?: string | null
  /** Text to search for, accross searchfields */
  searchText?: string | null
  sortOrder?: SortOrder
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
  /** Client Id */
  clientId?: string | null
}
export type BoardMeetingModel = {
  /** Id of meeting in HF */
  id?: string | null
  /** Title of meeting */
  title?: string | null
  /** Meeting description */
  description?: string | null
  /** Place where meeting should be held */
  place?: string | null
  /** Start time of meeting */
  from?: string
  /** Endtime of meeting */
  to?: string | null
  /** List of meeting participants */
  participants?: MeetingParticipantSelectedModel[] | null
  status?: MeetingStatus
  editingByUser?: PersonModel
  /** Client name */
  clientName?: string | null
}
export type BoardMeetingModelRead = {
  /** Id of meeting in HF */
  id?: string | null
  /** Title of meeting */
  title?: string | null
  /** Meeting description */
  description?: string | null
  /** Place where meeting should be held */
  place?: string | null
  /** Start time of meeting */
  from?: string
  /** Endtime of meeting */
  to?: string | null
  /** List of meeting participants */
  participants?: MeetingParticipantSelectedModelRead[] | null
  status?: MeetingStatus
  editingByUser?: PersonModel
  /** Client name */
  clientName?: string | null
}
export type CreateMeetingModel = {
  /** Id for client */
  clientId?: string | null
  /** Title of meeting */
  title?: string | null
  /** Meeting start time. */
  from?: string
  /** To given datetime. If not set will default to From + 1 hour */
  to?: string | null
}
export type MeetingCompletedRequestModel = {
  shareWithBbl?: boolean
}
export type DecisionVoteRequestModel = {
  nameId?: string | null
  vote?: VoteStatus
}
export type NewDecisionRequestModel = {
  decision?: string | null
  decisionStatus?: FinishCaseStatus
  votes?: DecisionVoteRequestModel[] | null
}
export type DecisionTextPutModel = {
  decision?: string | null
  isAutoSave?: boolean | null
}
export type SignedByUserModel = {
  signedByNameId?: string | null
  signedDate?: string
  signingType?: SigningType
  signedByFullName?: string | null
}
export type SignedByUserModelRead = {
  signedByNameId?: string | null
  signedDate?: string
  signingType?: SigningType
  signingTypeDescription?: string | null
  signedByFullName?: string | null
}
export type SignatureResponseModel = {
  id?: string | null
  referenceType?: SigningReferenceType
  referenceId?: string | null
  status?: SigningStatus
  createdByNameId?: string | null
  createdDate?: string
}
export type ProtocolSharedRequestModel = {
  /** True to share the meeting protocol with the house-building cooperative (dele med forretningsfører/boligbyggelaget).
    False to remove sharing. */
  shareWithBbl?: boolean
}
export enum TimelineEnumType {
  Comment = 'Comment',
  Log = 'Log',
}
export enum TimeLineLogActionEnum {
  Created = 'Created',
  Edited = 'Edited',
  Completed = 'Completed',
  Deleted = 'Deleted',
  Restored = 'Restored',
  CaseAdded = 'CaseAdded',
  CaseRemoved = 'CaseRemoved',
  AttachementAdded = 'AttachementAdded',
  AttachementRemoved = 'AttachementRemoved',
  DecisionRevoked = 'DecisionRevoked',
  NoticeSent = 'NoticeSent',
  MeetingResetToConductedNotCompletedByTechnicalSupportUser = 'MeetingResetToConductedNotCompletedByTechnicalSupportUser',
  MeetingResetToOngoingByTechnicalSupportUser = 'MeetingResetToOngoingByTechnicalSupportUser',
  AttachmentAddedFromBoardArchive = 'AttachmentAddedFromBoardArchive',
}
export enum MeetingStatus {
  New = 'New',
  Ongoing = 'Ongoing',
  ConductedNotCompleted = 'ConductedNotCompleted',
  CompletedNotYetSigned = 'CompletedNotYetSigned',
  CompletedManualSigning = 'CompletedManualSigning',
  CompletedAndSigned = 'CompletedAndSigned',
  Deleted = 'Deleted',
}
export enum CasesSortColumn {
  Title = 'Title',
  Status = 'Status',
  CaseType = 'CaseType',
  Responsible = 'Responsible',
  Deadline = 'Deadline',
  Created = 'Created',
}
export enum CaseQueryStatus {
  ActiveCases = 'ActiveCases',
  Completed = 'Completed',
  All = 'All',
  Deleted = 'Deleted',
  ActiveCasesThatCanBeAddedToMeeting = 'ActiveCasesThatCanBeAddedToMeeting',
  NewCasesThatCanBeAddedToMeeting = 'NewCasesThatCanBeAddedToMeeting',
  ForFollowupCasesThatCanBeAddedToMeeting = 'ForFollowupCasesThatCanBeAddedToMeeting',
  PostponedCasesThatCanBeAddedToMeeting = 'PostponedCasesThatCanBeAddedToMeeting',
  New = 'New',
  Ongoing = 'Ongoing',
  ForFollowup = 'ForFollowup',
  Postponed = 'Postponed',
}
export enum SortOrder {
  Ascending = 'Ascending',
  Descending = 'Descending',
}
export enum CaseType {
  DecisionCase = 'DecisionCase',
  OrientationCase = 'OrientationCase',
  FollowUpCase = 'FollowUpCase',
}
export enum CaseStatus {
  New = 'New',
  Ongoing = 'Ongoing',
  Completed = 'Completed',
  Deleted = 'Deleted',
  ForFollowup = 'ForFollowup',
  Postponed = 'Postponed',
}
export enum MessageType {
  Email = 'Email',
  Sms = 'Sms',
}
export enum VoteStatus {
  Against = 'Against',
  For = 'For',
  NotVoted = 'NotVoted',
}
export enum MeetingsSortColumn {
  Title = 'Title',
  Time = 'Time',
  AttendantCount = 'AttendantCount',
  CaseCount = 'CaseCount',
  Status = 'Status',
}
export enum MeetingQueryStatus {
  All = 'All',
  Active = 'Active',
  ActiveMeetingsThatCanBeConnectedToCases = 'ActiveMeetingsThatCanBeConnectedToCases',
  Completed = 'Completed',
  ActiveUpcoming = 'ActiveUpcoming',
}
export enum FinishCaseStatus {
  Complete = 'Complete',
  Followup = 'Followup',
  Postpone = 'Postpone',
}
export enum SigningType {
  Styreleder = 'Styreleder',
  Styremedlem = 'Styremedlem',
  BblRepresentant = 'BblRepresentant',
  Aarsmoeteleder = 'Aarsmoeteleder',
  Aarsmoetesekretaer = 'Aarsmoetesekretaer',
  Aarsmoetevitne = 'Aarsmoetevitne',
  Varamedlem = 'Varamedlem',
  DagligLeder = 'DagligLeder',
}
export enum SigningReferenceType {
  DokumentAageAgreement = 'DokumentAageAgreement',
  BoardmeetingProtocol = 'BoardmeetingProtocol',
  Budget = 'Budget',
  DeclarationOfCompleteness = 'DeclarationOfCompleteness',
  AnnualAccounts = 'AnnualAccounts',
  Expenses = 'Expenses',
  AnnualMeetingProtocol = 'AnnualMeetingProtocol',
}
export enum SigningStatus {
  SentToPortal = 'SentToPortal',
  FinishedPortal = 'FinishedPortal',
  TotalFinished = 'TotalFinished',
}
export const {
  useGetCasesByCaseIdCommentsQuery,
  usePostCasesByCaseIdCommentsMutation,
  usePutCasesByCaseIdCommentsAndCommentIdMutation,
  useDeleteCasesByCaseIdCommentsAndCommentIdMutation,
  useGetBoardperiodsQuery,
  usePostCasesByCaseIdAttachmentsMutation,
  useGetCasesByCaseIdAttachmentsQuery,
  useGetCasesByCaseIdAttachmentsAndAttachmentIdQuery,
  useDeleteCasesByCaseIdAttachmentsAndAttachmentIdMutation,
  usePostCasesListQuery,
  useGetCasesByCaseIdQuery,
  usePutCasesByCaseIdMutation,
  usePutCasesByCaseIdDeletedMutation,
  usePostCasesMutation,
  usePutCasesByCaseIdDescriptionMutation,
  usePutCasesByCaseIdSuggesteddecisionMutation,
  useGetMeetingsByMeetingIdAgendaQuery,
  usePutMeetingsByMeetingIdAgendaMutation,
  usePutMeetingsByMeetingIdAgendaAndCaseIdMutation,
  useDeleteMeetingsByMeetingIdAgendaAndCaseIdMutation,
  useGetMeetingsByMeetingIdAgendaAndCaseIdQuery,
  useGetMeetingsByMeetingIdCommentsQuery,
  usePostMeetingsByMeetingIdCommentsMutation,
  usePutMeetingsByMeetingIdCommentsAndCommentIdMutation,
  useDeleteMeetingsByMeetingIdCommentsAndCommentIdMutation,
  useGetMeetingsByMeetingIdParticipantsForeditQuery,
  useGetMeetingsByMeetingIdParticipantsQuery,
  usePatchMeetingsByMeetingIdParticipantsMutation,
  usePostMeetingsByMeetingIdEmailnotificationAllMutation,
  usePostMeetingsByMeetingIdEmailnotificationMutation,
  useGetMeetingsByMeetingIdProtocolQuery,
  usePostMeetingsListQuery,
  useGetMeetingsByMeetingIdQuery,
  usePatchMeetingsByMeetingIdMutation,
  useDeleteMeetingsByMeetingIdMutation,
  useGetMeetingsByMeetingIdNoticeQuery,
  useGetMeetingsByMeetingIdEventQuery,
  usePostMeetingsMutation,
  usePostMeetingsByMeetingIdOngoingMutation,
  usePostMeetingsByMeetingIdEditingUserMutation,
  usePostMeetingsByMeetingIdCancelledMutation,
  usePostMeetingsByMeetingIdConductedMutation,
  usePostMeetingsByMeetingIdCompletedMutation,
  usePutMeetingsByMeetingIdCasesAndCaseIdDecisionMutation,
  usePutMeetingsByMeetingIdCasesAndCaseIdDecisionTextMutation,
  usePostMeetingsByMeetingIdCasesAndCaseIdDecisionRevertedMutation,
  usePostMeetingsByMeetingIdSigningcancelledMutation,
  usePostMeetingsByMeetingIdSignedMutation,
  useGetMeetingsByMeetingIdProtocolSigningSignatoriesQuery,
  useGetMeetingsByMeetingIdProtocolSigningQuery,
  usePutMeetingsByMeetingIdProtocolSharedMutation,
  usePostMeetingsByMeetingIdCompletedandsignedcancelledMutation,
  usePostMeetingsByMeetingIdConductedcancelledMutation,
  usePostCasesByCaseIdAttachmentsBoardarchiveMutation,
} = injectedRtkApi
